import * as React from 'react'

type ProgressProps = {
  value: number // 0..100
  className?: string
}

export function Progress({ value, className }: ProgressProps) {
  const cl = `w-full h-2 bg-gray-200 dark:bg-gray-800 rounded overflow-hidden ${className || ''}`
  const pct = Math.max(0, Math.min(100, value || 0))
  return (
    <div className={cl} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct} role="progressbar">
      <div
        className="h-full bg-primary transition-[width] duration-200"
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}

